import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProductTreeService {
  constructor(private httpClient: HttpClient) {}

  createEntity(entityId: string, productTypeId: string, productName: string | null, defaultValues: any[]): Observable<string> {
    return this.httpClient
      .post<string>(`${environment.apiUrl}/products/${entityId}`, {
        ProductTypeId: productTypeId,
        ProductName: productName,
        DefaultValues: defaultValues
      })
      .pipe(take(1));
  }

  delete(idList: string[]): Observable<any> {
    const httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.httpClient
      .delete<string[]>(`${environment.apiUrl}/products`, {
        headers: httpHeaders,
        body: idList
      })
      .pipe(take(1));
  }

  copy(id: string, parentId: string): Observable<string> {
    return this.httpClient.post<string>(`${environment.apiUrl}/products/${id}/copy/${parentId}`, {}).pipe(take(1));
  }
}
